// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nx-0";
export var animationContainer = "_nx-1";
export var itemPrice = "_nx-a";
export var itemizedContent = "_nx-9";
export var itemizedHeader = "_nx-7";
export var itemizedRow = "_nx-8";
export var itemizedSection = "_nx-6";
export var modalContent = "_nx-2";
export var orderName = "_nx-3";
export var refundOption = "_nx-4";
export var refundOptionsContainer = "_nx-5";
export var shippingLabel = "_nx-b";
export var totalRow = "_nx-c";